import { useEffect, useRef } from "react";
// import Skeleton from "@mui/material/Skeleton";

function VideoItem({ curr, small }: any) {
  const refVideo = useRef<HTMLVideoElement>(null);
  useEffect(() => {
    if (!refVideo.current || !curr) return;
    refVideo.current.srcObject = curr.srcObject;
  }, [curr]);
  
  return (
    <div className="player_video_item">
      <video
        style={{
          width: "100%",
          // minWidth: small? 70: 150,
          // minHeight: small? 70: 150,
          backgroundColor: "black",
        }}
        onError={() => console.log(" ERRROR VIDEO ITEM")}
        onLoad={() => console.log(" ************************ load ")}
        autoPlay={true}
        ref={refVideo}
      />
    </div>
  );
}

export default VideoItem;
